import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import colorContext from '../../../../Context/colorContext'
import { HomeCategoryEmphasisProps } from '../..'
import { useStyles } from './styles'

interface Props {
  listCategoryEmphasis: HomeCategoryEmphasisProps[]
}

export default function ServiceProfile({
  listCategoryEmphasis,
}: Props): JSX.Element {
  const { colors } = useContext(colorContext)
  const classes = useStyles({ colors })
  const matches = useMediaQuery('(min-width:755px)')

  return (
    <Box className={classes.main}>
      <Box
        display="flex"
        maxWidth="1320px"
        width="100%"
        flexDirection="column"
        marginTop="50px"
        marginBottom="30px"
      >
        <Box className={classes.box}>
          <Typography
            className={classes.textTitleInitial}
            variant="h5"
            component="h2"
          >
            Serviços em destaque
          </Typography>
        </Box>

        <Box
          display="flex"
          justifyContent={matches ? 'space-evenly' : 'center'}
          flexWrap="wrap"
          alignItems="center"
          width="100%"
        >
          {listCategoryEmphasis?.slice(0, 6).map((category) => (
            <Card key={category.id.toString()} className={classes.card}>
              <div style={{ textAlign: 'center', width: '100%' }}>
                <Typography className={classes.textTitle}>
                  {category.categoria}
                </Typography>
              </div>
              <Box className={classes.cardSecondary}>
                <Link
                  to={`/servico/${category.servico1.slug}`}
                  className={classes.textLink}
                >
                  {category.servico1.titulo}{' '}
                  <ArrowForwardIcon className={classes.arrowIcon} />
                </Link>
                <Link
                  to={`/servico/${category.servico2.slug}`}
                  className={classes.textLink}
                >
                  {category.servico2.titulo}{' '}
                  <ArrowForwardIcon className={classes.arrowIcon} />
                </Link>
              </Box>
            </Card>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
